import styled from 'styled-components'

import { DescriptionItemValueStyled } from '../components/DescriptionItem/styles/DescriptionItemValueStyled'
import { type IDescriptionsProps } from '../Descriptions'
import { DividerStyled } from '@ui/elements/Divider/styles/DividerStyled'

interface IDescriptionsStyledProps {
  size: IDescriptionsProps['size']
  columns: IDescriptionsProps['columns']
  valueWidth: IDescriptionsProps['valueWidth']
  valueAlign: IDescriptionsProps['valueAlign']
  wrapLabelText: IDescriptionsProps['wrapLabelText']
}

const getValueColumnTemplate = (
  valueWidth: IDescriptionsStyledProps['valueWidth']
) => {
  let valueColumnSize = 'auto'

  if (typeof valueWidth === 'number') {
    valueColumnSize = `${valueWidth}px`
  } else if (typeof valueWidth === 'string') {
    switch (valueWidth) {
      case 'fluid':
        valueColumnSize = 'minmax(min-content, max-content)'
        break
      case 'fill':
        valueColumnSize = 'minmax(min-content, 1fr)'
        break
    }
  }

  return `minmax(min-content, max-content) ${valueColumnSize}`
}

export const DescriptionsStyled = styled.dl<IDescriptionsStyledProps>`
  display: grid;

  grid-template-columns: repeat(
    ${(props) => props.columns},
    ${(props) => getValueColumnTemplate(props.valueWidth)}
  );

  label,
  ${DescriptionItemValueStyled} {
    padding: ${(props) =>
        props.size === 'normal'
          ? props.theme.space.small
          : props.theme.space.xsmall}
      0;
    padding-left: ${(props) =>
      props.size === 'normal'
        ? props.theme.space.large
        : props.theme.space.medium};

    display: flex;

    align-items: start;
  }

  label {
    font-size: ${(props) => props.theme.typography.pxToRem(12)};
    font-weight: ${(props) => props.theme.fontWeights.bold};
    color: ${(props) => props.theme.colors.darkGrey};

    ${(props) => !props.wrapLabelText && `white-space: nowrap;`}
  }

  ${DescriptionItemValueStyled} {
    font-size: ${(props) =>
      props.size === 'small'
        ? props.theme.typography.pxToRem(props.theme.fontSizes.body2)
        : props.theme.typography.pxToRem(props.theme.fontSizes.body1)};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    ${(props) =>
      props.valueAlign === 'right' &&
      `
    justify-content: end;
    text-align: right;
    `}
  }

  label:nth-of-type(${(props) => props.columns}n + 1),
  label:first-of-type {
    padding-left: 0;
  }

  ${DividerStyled} {
    grid-column: 1/-1;
  }
`
